const updateGeozone = (state, action) => {
  if(state===undefined || action?.type==='RESET'){
    return {
      geozoneArr: undefined,
      geozoneSettingsArr: undefined,
      geozoneVertexArr: undefined,
      geozoneIntersections: undefined
    }
  }
  const { geozone:data } = state;

  switch(action.type){
    case 'SET_GEOZONE_GEOZONE_ARR':
      return {...data, geozoneArr: action.payload};
    case 'SET_GEOZONE_GEOZONE_SETTINGS_ARR':
      return {...data, geozoneSettingsArr: action.payload};
    case 'SET_GEOZONE_GEOZONE_VERTEX_ARR':
      return {...data, geozoneVertexArr: action.payload};
    case 'SET_GEOZONE_GEOZONE_INTERSECTIONS':
      return {...data, geozoneIntersections: action.payload};

    default:
      return data;
  }
}

export default updateGeozone;
